// extracted by mini-css-extract-plugin
export default {"table":"style_table__2xTVP","kycContent":"style_kycContent__28RIt","kycField":"style_kycField__n0g9t","label":"style_label__eu+Mk","value":"style_value__MlGIC"};